var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trust-list',{ref:"loadmore",on:{"load":_vm.load}})
}
var staticRenderFns = []

export { render, staticRenderFns }